export const LIST_VIEWS = ['table', 'board', 'calendar', 'timeline'];
export const LIST_VIEW_KEY = 'list.view';
const LEGACY_BOARD_KEY = 'list.board';
/** The presentations a list offers: the table, then each one whose block it declares and `drawn` can draw, in the order of LIST_VIEWS. */
export function viewsOffered(manifest, drawn) {
    const blocks = manifest;
    return LIST_VIEWS.filter((v) => v === 'table' || (drawn.includes(v) && Boolean(blocks[v])));
}
/** The presentation in view: the viewer's own choice for this screen, else what the manifest opens as. */
export function viewShown(manifest, chosen, drawn) {
    const offered = viewsOffered(manifest, drawn);
    const mine = chosen[manifest.screen];
    if (mine && offered.includes(mine))
        return mine;
    const layout = manifest.layout;
    if ((layout === 'calendar' || layout === 'timeline') && offered.includes(layout))
        return layout;
    if ((layout === undefined || layout === 'table') && manifest.board?.opens === 'board' && offered.includes('board'))
        return 'board';
    return 'table';
}
/**
 * The viewer's choices, by screen. The board's older key is read once: its choices become this
 * key's and it is removed, so nothing reads two keys that could disagree. Storage may be refused (a
 * private window); then nothing is chosen, and every list opens as its manifest says.
 */
export function readChosenViews(store = globalThis.localStorage) {
    try {
        const now = store?.getItem(LIST_VIEW_KEY);
        if (now)
            return JSON.parse(now);
        const legacy = store?.getItem(LEGACY_BOARD_KEY);
        if (!legacy)
            return {};
        const read = JSON.parse(legacy);
        store?.setItem(LIST_VIEW_KEY, JSON.stringify(read));
        store?.removeItem(LEGACY_BOARD_KEY);
        return read;
    }
    catch {
        return {};
    }
}
export function keepChosenViews(chosen, store = globalThis.localStorage) {
    try {
        store?.setItem(LIST_VIEW_KEY, JSON.stringify(chosen));
    }
    catch { /* kept for this visit only */ }
}
//# sourceMappingURL=list-views.js.map